<!-- 发布服务 -->
<template>
  <div class="service-wp">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">发布"技能服务"</div>
      </el-col>
    </el-row>
    <el-row>
      <div class="service-xp">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="选择类型：" prop="pushType">
            <el-col :span="10">
              <el-cascader
                :options="serviceTypeArr"
                placeholder="请选择服务类型"
                change-on-select
                v-model="ruleForm.pushType">
              </el-cascader>
            </el-col>
          </el-form-item>

          <el-form-item label="服务标题：" prop="title">
            <el-col :span="10">
              <el-input v-model="ruleForm.title" placeholder="请输入服务标题描述" maxlength="15"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="服务售价：" prop="pushPrice">
            <el-col :span="5">
              <el-input v-model="ruleForm.pushPrice" type="number" placeholder="请输入售价金额" maxlength="10"></el-input>
            </el-col>
            <el-col :span="1">
              元 /
            </el-col>
            <el-col class="grid-from" :span="6">
              <el-select v-model="ruleForm.servePriceType" placeholder="选择售价单位">
                <el-option
                  v-for="item in serviceUnitsArr"
                  :key="item.code"
                  :label="item.serveUnit"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>


          <el-form-item label="服务方式：" prop="serveStyleType">
            <el-col :span="20">
              <el-checkbox-group v-model="ruleForm.serveStyleType" size="small">
                <el-checkbox-button v-for="item in serviceModeArr" :label="item" :key="item">{{item}}</el-checkbox-button>
              </el-checkbox-group>
            </el-col>
          </el-form-item>

          <el-form-item label="服务时间：" prop="serveTimeInterval">
            <el-col :span="20">
              <el-checkbox-group v-model="ruleForm.serveTimeInterval" size="small">
                <el-checkbox-button v-for="item in serviceTimeArr" :label="item" :key="item">{{item}}</el-checkbox-button>
              </el-checkbox-group>
            </el-col>
          </el-form-item>

          <el-form-item label="服务城市：">
            <el-col :span="5">
              <el-form-item prop='serveProvinceCode'>
                <el-select v-model="ruleForm.serveProvinceCode " placeholder="省份" @change="changeProvinceNow">
                  <el-option v-for="(item,index) in addressArr" :label="item.label" :value="item.value" :key="index" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="grid-from" :span="5">
              <el-form-item prop='serveCityCode'>
                <el-select v-model="ruleForm.serveCityCode" placeholder="市" @change="changeCityNow">
                  <el-option v-for="item in cityArrNow" :label="item.label" :value="item.value" :key="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="grid-from" :span="5">
              <el-form-item prop='serveAreaCode'>
                <el-select v-model="ruleForm.serveAreaCode" placeholder="区、县">
                  <el-option v-for="item in countyArrNow" :label="item.label" :value="item.value" :key="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="封面图片：" prop="serveCoverImg">
            <el-upload
              class="avatar-uploader"
              action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="ruleForm.serveCoverImg" :src="ruleForm.serveCoverImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon el-border"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="服务详情：" prop="description" >
            <div style="height: 350px">
              <quill-editor
                v-model="ruleForm.description"
                ref="myQuillEditor"
                style="height: 300px"
                :options="editorOption"
                @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                @change="onEditorChange($event)">
              </quill-editor>
            </div>
          </el-form-item>

<!--          <el-form-item label="费用包含：" prop="servePriceArrayStr">-->
<!--            <el-col :span="10">-->
<!--              <el-select v-model="ruleForm.servePriceArrayStr" placeholder="请选择费用包含项" @change="changePrice">-->
<!--                <el-option v-for="item in servicePriceArr" :label="item.priceUnit" :value="item.code" :key="item"></el-option>-->
<!--              </el-select>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
<!--          <el-form-item v-show="is_price_show">-->
<!--            <div v-for="(item,index) in priceInforChange" :key="index">-->
<!--              <el-row :gutter="0" class="dashed">-->
<!--                <el-col :span="2"><span>{{item.unitName}}：</span></el-col>-->
<!--                <el-col :span="5">-->
<!--                  <el-input v-model="item.price" placeholder="请输入售价金额"></el-input>-->
<!--                </el-col><el-col :span="5"> <span>元</span>  <span class="del-btn" @click="delPriceItem(item,index)">删除</span></el-col>-->
<!--              </el-row>-->
<!--            </div>-->
<!--          </el-form-item>-->
          <el-form-item label="费用包含：" prop="contain">
            <el-input type="textarea" placeholder="请输入费用包含内容" v-model="ruleForm.contain"></el-input>
          </el-form-item>
          <el-form-item label="费用不包含：" prop="priceExcluded">
            <el-input type="textarea" placeholder="请输入费用不包含项（选填）" v-model="ruleForm.priceExcluded"></el-input>
          </el-form-item>

          <el-form-item label="补充说明：" prop="addDescription">
            <el-input type="textarea" placeholder="请输入补充说明（选填）" v-model="ruleForm.addDescription"></el-input>
          </el-form-item>

          <el-form-item style="text-align: center">
            <el-button type="primary" @click="submitForm('ruleForm')">立即发布服务</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>

  </div>
</template>

<script>
  import { insertServes, getServeData, getCityData} from 'api/apis'
  import { quillEditor } from 'vue-quill-editor'
   // require styles 引入样式
  require('quill/dist/quill.core.css')
  require('quill/dist/quill.snow.css')
  require('quill/dist/quill.bubble.css')

  export default {
    components:{
      "quill-editor": quillEditor,
    },
    data() {
      return {
        userCode: localStorage.getItem('pbw_user_pc_uid'),
        editorOption: {
           modules:{
              toolbar:[
                // 'italic', 'underline', 'strike'
                ['bold'],        // toggled buttons
                // ['blockquote', 'code-block',],//标点
                ['image'],//图片
                //[{'header': 1 }, {'header': 2 }],
                //[{ 'list': 'ordered'}, { 'list': 'bullet' }], //值ordered，bullet
                //[{ 'indent': '-1'}, { 'indent': '+1' }], //值-1，+1等
              ]
          },
          placeholder: '请输入服务内容描述...',
        },
        ruleForm: {
          pushType: [],//发布类型
          title: '',//发布标题
          serveStyleType: [],//服务方式类型（多选）
          serveTimeInterval: [],//服务时间区间
          pushPrice: '',//服务售价
          servePriceType: '',//服务售价单位
          serveCityCode: '',//服务市区code
          serveAreaCode: '',//服务地区code
          servePriceName: '',//服务价格类型名称
          priceExcluded: '',//服务不包含说明
          contain:'',//包含说明
          addDescription: '',//补充说明
          servePriceArrayStr: '',//服务价目列表字符串
          serveCoverImg: '',//服务封面图片
          description: '',//发布详情
        },
        rules: {
          pushType: [
            // { required: true, message: '请选择服务类型', trigger: 'blur' },
            { type: 'array', required: true, message: '请至少选择一个服务类型', trigger: 'change' }
          ],
          title: [
            { required: true, message: '请输入发布服务标题', trigger: 'change' }
          ],
          pushPrice: [
            { required: true, message: '请选择服务售价', trigger: 'blur' }
          ],
          servePriceType:[
            { required: true, message: '请选择服务售价单位', trigger: 'change' }
          ],
          serveStyleType: [
            { type: 'array', required: true, message: '请至少选择一个服务方式', trigger: 'change' }
          ],
          serveTimeInterval: [
            { type: 'array', required: true, message: '请至少选择一个发布服务时间', trigger: 'change' }
          ],
          serveCoverImg: [
            { required: true, message: '请上传服务封面'}
          ],
          serveProvinceCode: [
            { required: true, message: '请选择服务地区', trigger: 'change' }
          ],
          serveCityCode: [
            { required: true, message: '请选择服务地区', trigger: 'change' }
          ],
          serveAreaCode: [
            { required: true, message: '请选择服务地区', trigger: 'change' }
          ],
          servePriceName: [
            { required: true, message: '请选择服务价格名称', trigger: 'change' }
          ],
          description: [
            { required: true, message: '请输入发布服务详情', trigger: 'blur' }
          ],
          contain: [
            { required: true, message: '请输入费用包含', trigger: 'blur' }
          ]
        },


        serviceTypeArr: [],//服务类型
        servicePriceArr: [],//服务价格
        serviceUnitsArr: [],//服务单位
        addressArr: [],//地区
        cityArrNow: [],//市级
        countyArrNow: [],//区级
        serviceModeArr: ['线上服务','线下服务','电话咨询','Ta来找我','我去找Ta'],
        serviceTimeArr: ['周一','周二','周三','周四','周五','周六','周日',],

        is_price_show: false,
        priceInforChange: [],//价目选择详情
        imgHead:{
          code: localStorage.getItem("pbw_user_pc_uid"),
          loginType: '1',
          loginKey: localStorage.getItem("pbw_user_pc_loginKey"),
          secretKey: localStorage.getItem("pbw_user_pc_secretKey"),
        },
      };
    },
    methods: {
      onEditorBlur(){//失去焦点事件
        
      },
      onEditorFocus(){//获得焦点事件
        
      },
      onEditorChange(){//内容改变事件
        
      },
      handleAvatarSuccess(res, file) {
        
        this.imageUrl = URL.createObjectURL(file.raw);
        this.ruleForm.serveCoverImg = res.data.ossFileName
      },
      beforeAvatarUpload(file) {
        // 上传格式判断
        if (!/.(jpg|jpeg|png|bmp|JPG|JPEG|PNG|BPM)$/.test(file.name)) {
          this.$message.error('文件格式只能是jpeg、jpg、PNG、bmp中的一种!')
          return false
        }
        if (file.size > 100 * 1024 * 1024) {
          this.$message.error('文件大小超过限制')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '上传中～',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1500);
      },
      delPriceItem (item,index) {
        
        this.priceInforChange.splice(index, 1);
        
      },
      changePrice (val) {//包含费用
        for (let item of this.servicePriceArr) {
          let obj = {}
          if(item.code == val){
            obj.unitName = item.priceUnit
            // obj.code = item.code
            obj.price = ''
            this.priceInforChange.push(obj)
          }
        }
        this.is_price_show = true
      },
      changeProvinceNow (val) {
        this.ruleForm.serveCityCode = ''
        for(let i=0; i<this.addressArr.length; i++){
          if(this.addressArr[i].value == val){
            this.cityArrNow = this.addressArr[i].children
          }
        }
      },
      changeCityNow (val) {
        this.ruleForm.serveAreaCode = ''
        for(let i=0; i<this.cityArrNow.length; i++){
          if(this.cityArrNow[i].value == val){
            this.countyArrNow = this.cityArrNow[i].children
          }
        }
      },
      submitForm(formName) {
        console.log(Number(this.ruleForm.pushPrice).toFixed(2))
        this.$refs[formName].validate((valid) => {
          if (valid) {
            
            let params = {
              userCode: this.userCode,
              pushType: this.ruleForm.pushType[1],
              title: this.ruleForm.title,
              pushPrice:Number(this.ruleForm.pushPrice).toFixed(2),
              description: this.ruleForm.description,
              servePriceType: this.ruleForm.servePriceType,
              serveStyleType: this.ruleForm.serveStyleType.toString(),
              serveTimeInterval: this.ruleForm.serveTimeInterval.toString(),
              serveCoverImg: this.ruleForm.serveCoverImg,
              serveProvinceCode: this.ruleForm.serveProvinceCode,
              serveCityCode: this.ruleForm.serveCityCode,
              serveAreaCode: this.ruleForm.serveAreaCode,
              priceExcluded: this.ruleForm.priceExcluded,
              addDescription: this.ruleForm.addDescription,
              // servePriceArrayStr: JSON.stringify(this.priceInforChange),
              servePriceArrayStr: this.ruleForm.contain,
            }

            for (let item of this.serviceUnitsArr) {
              if (this.ruleForm.servePriceType  == item.code) {
                params.servePriceName = item.serveUnit
              }
            }

            insertServes(params).then((res) => {
              if (res.code == '000000') {
                this.$router.push('/home/servicesList')
                this.$message.success("发布技能成功！")
              } else {
                this.$message.warning("发布失败！")
              }
            })
          } else {
            this.$message.warning("请补全发布内容")
            return false;
          }
        });
      },
    },
    created () {
      getServeData({}).then((res) => {
        if (res.code == '000000') {
          let serviceArr = [], num1=1;
          for(let item in res.data.pushServes){
            if(res.data.pushServes[item].serveSort == num1){
              let data ={
                'label':res.data.pushServes[item].serveSortName,
                'value':res.data.pushServes[item].serveSort,
                'children':[]
              }
              for(let index in res.data.pushServes){
                if(res.data.pushServes[index].serveSort == num1){
                  res.data.pushServes[index].value = res.data.pushServes[index].code
                  res.data.pushServes[index].label = res.data.pushServes[index].serveName
                  data.children.push(res.data.pushServes[index])
                }
              }
              this.serviceTypeArr.push(data)
              num1 ++
            }
          }
          //服务价格
          this.servicePriceArr = res.data.servePrices
          //服务单位
          this.serviceUnitsArr = res.data.serveUnits

        } else {
          this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
        }
      })
      getCityData({}).then((res) => {
        if (res.code == '000000') {
          let address = [],province = [];
          //城市数据
          address = res.data.result;

          for(let pro of res.data.result){
            let city = [];
            let ss = {
              'value':pro.id,
              'label':pro.areaname,
              'children':city
            }
            province.push(ss);
            for(let cit of pro.result){
              let area = [];
              let s = {
                'value':cit.id,
                'label':cit.areaname,
                'children':area
              }
              city.push(s);
              for(let are of cit.result){
                let q = {
                  'value':are.id,
                  'label':are.areaname,
                  'children':[]
                }
                area.push(q)
              }
            }
          }

          this.addressArr = province;
        } else {
          this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
        }
      })
    },
    mounted () {

    }
  }
</script>

<!--css样式-->
<style lang="scss" scoped>
    @import '../../../src/scss/commonH5.scss';
    @import '../../scss/demo.scss';
    .quill-editor{
      height: 70%;
    }
    .avatar{
      height: 120px;
      border: 1px solid #d6d6d6;
    }
    .service-wp .dashed {
      border-bottom: 1px dashed #F1F1F1;
      padding-bottom: 20px;
      margin-bottom: 25px;
    }
    .service-wp .title1 {
      font-size: 18px;
      color: #333;
    }
    .service-wp .title1::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 27px;
      border-radius: 5px;
      vertical-align: bottom;
      background-color: #F16202;
      margin-right: 20px;
    }
    .service-wp{
      .service-xp{
        width: 100%;
        margin: 0 auto;
      }
      .grid-from{
        margin-left: 10px;
      }
      .dashed{
        margin: 10px 0px;
      }
      .del-btn{
        font-size: 16px;
        color: #f60;
      
      }
      .avatar{
        height: 160px;
        border: 1px solid #d6d6d6;
      }
      .el-border{
        width: 160px;
        height: 160px;
        line-height: 160px;
        border: 1px solid #ddd;
        text-align: center;
      }
    }

</style>



// WEBPACK FOOTER //
// src/views/home/service.vue